export default __webpack_public_path__ + "static/media/ShadowyCaveMap.7a5c8fde.jpg";